exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (max-width: 1024px){.logo-container[data-v-1fe52f6a]{width:75%;margin:0 auto;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;height:44px;-ms-flex-align:center;align-items:center}}\n", ""]);

// exports
